import React from 'react';

import { getDefault, readCMSValue, buildCMSStyles } from 'modules/shared-cms/utils';
import { TextColorProps } from 'modules/shared-cms/cms-base-type';
import { HtmlContainer } from 'modules/shared-ui/components';

import { TitleBlocContainer } from 'modules/shared-cms-advanced';
import { GameParticipationConfirmationProps } from './game-participation-confirmation-type';

import enhancer from './game-participation-confirmation-enhancer';

import styles from './game-participation-confirmation-page.module.css';

const InnerPage: React.FC<GameParticipationConfirmationProps> = React.memo(
    ({ game }: GameParticipationConfirmationProps) => {
        const htmlContainerProps = {
            style: buildCMSStyles<TextColorProps>({ textColor: game.confirmationTextColor }),
            htmlContent: getDefault(readCMSValue(game.confirmationText), ''),
        };

        return (
            <React.Fragment>
                <div className={styles.confirmContainer}>
                    <HtmlContainer {...htmlContainerProps} />
                </div>
                <TitleBlocContainer {...game} />
            </React.Fragment>
        );
    },
);

export const GameParticipationConfirmationPage = enhancer(InnerPage);
